import { z } from "zod";
import { COUNTDOWN_SECONDS_VALUES, DECISION_CHOICES_MAX, DECISION_CHOICES_MIN } from "../../constants/decision.js";
import { CHOICE_LABEL_MAX_LENGTH, CHOICE_SUBTITLE_MAX_LENGTH, DECISION_QUESTION_MAX_LENGTH } from "../../constants/limits.js";
import { FlagEffectSchema } from "./flags.js";
const ALLOWED_COUNTDOWN_SECONDS = new Set(COUNTDOWN_SECONDS_VALUES);
export const ChoiceSchema = z.object({
    id: z.uuid(),
    label: z.string().min(1).max(CHOICE_LABEL_MAX_LENGTH),
    subtitle: z.string().max(CHOICE_SUBTITLE_MAX_LENGTH).nullable(),
    nextNodeId: z.uuid(),
    effects: z.array(FlagEffectSchema),
    orderIndex: z.number().int().nonnegative(),
});
export const DecisionSchema = z
    .object({
    id: z.uuid(),
    question: z.string().min(1).max(DECISION_QUESTION_MAX_LENGTH),
    timeoutSeconds: z
        .number()
        .int()
        .refine((value) => ALLOWED_COUNTDOWN_SECONDS.has(value), "Durée de countdown non autorisée"),
    defaultChoiceId: z.uuid(),
    choices: z.array(ChoiceSchema).min(DECISION_CHOICES_MIN).max(DECISION_CHOICES_MAX),
})
    .refine((decision) => decision.choices.some((choice) => choice.id === decision.defaultChoiceId), "defaultChoiceId doit référencer un choix de la décision");
